const TEMPLATE_CATEGORY_FIELDS = `
  templateCategory {
    id
    name
  }
`;

const TEMPLATE_FIELDS = `
  id
  key
  body
  templateType
  name
  emailSubject
  ${TEMPLATE_CATEGORY_FIELDS}
`;

export const GET_CONTACT_LEVELS = `
  query GetContactLevels($page: ID){
    contactLevels(page: $page) {
      id
      level
      name
    }
  }
`;

export const ASSIGN_ATTACHMENT_TO_TEMPLATE = `
  mutation AssignAttachmentsToTemplate($attachmentIds: [ID!]!, $templateId: ID!) {
    assignAttachmentsToTemplate(attachmentIds: $attachmentIds, templateId: $templateId) {
      template {
        templateAttachments {
          id
          attachment {
            id
            url
          }
        }
      }
    }
  }
`;

export const UNASSIGN_ATTACHMENT_FROM_TEMPLATE = `
  mutation UnassignAttachmentFromTemplate($id: ID!) {
    unassignAttachmentFromTemplate(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export const ASSIGN_CONTACT_LEVEL_TO_TEMPLATE = `
  mutation AssignContactLevelToTemplate($contactLevelIds: [ID!]!, $templateId: ID!){
    assignContactLevelToTemplate(contactLevelIds: $contactLevelIds, templateId: $templateId) {
      contactLevels {
        id
        level
        name
      }
      errors {
        property
        description
      }
    }
  }
`;

export const ASSIGN_CC_CONTACT_LEVEL_TO_TEMPLATE = `
  mutation AssignCcContactLevelToTemplate($contactLevelIds: [ID!]!, $templateId: ID!){
    assignCcContactLevelToTemplate(contactLevelIds: $contactLevelIds, templateId: $templateId) {
      ccContactLevels {
        id
        level
        name
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_EMAIL_TEMPLATE = `
  mutation createEmailTemplate($body: String!, $templateType: String!, $templateCategoryId: ID, $emailSubject: String!, $name: String!) {
    createTemplate(body: $body, name: $name, emailSubject: $emailSubject, templateType: $templateType, templateCategoryId: $templateCategoryId) {
      template{
        ${TEMPLATE_FIELDS}
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_EMAIL_TEMPLATE = `
  query GetEmailTemplate($id: ID!){
    template(id: $id) {
      ${TEMPLATE_FIELDS}
      templateAttachments {
        id
        attachment {
          id
          url
        }
      }
      recipientTemplateContactLevels {
        id
        contactLevel {
          id
          name
          level
        }
      }
      recipientTemplateCcContactLevels {
        id
        contactLevel {
          id
          name
          level
        }
      }
    }
  }
`;

export const UPDATE_EMAIL_TEMPLATE = `
  mutation UpdateEmailTemplate($id: ID!, $body: String!, $templateType: String!, $templateCategoryId: ID, $emailSubject: String!, $name: String!) {
    updateTemplate(id: $id, body: $body, name: $name, emailSubject: $emailSubject, templateType: $templateType, templateCategoryId: $templateCategoryId) {
      template{
        ${TEMPLATE_FIELDS}
        templateAttachments {
          id
          attachment {
            id
            url
          }
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_TEMPLATES = `
  query GetTemplates($page: ID, $q: String, $templateType: String, $templateCategoryId: ID, $numberPerPage: Int) {
    templatesFilter(page: $page, q: $q, templateType: $templateType, templateCategoryId: $templateCategoryId, numberPerPage: $numberPerPage) {
      count
      results {
        ${TEMPLATE_FIELDS}
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_TEMPLATE_OPTIONS = `
  query GetTemplateOptions($templateCategoryKeywords: [String!]) {
    templates(templateCategoryKeywords: $templateCategoryKeywords) {
      ${TEMPLATE_FIELDS}
    }
  }
`;

export const GET_TEMPLATE_CATEGORIES = `
  query GetTemplateCategories($page: ID, $q: String, $numberPerPage: Int) {
    templateCategories(page: $page, q: $q, numberPerPage: $numberPerPage) {
      count
      results {
        id
        name
        description
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_TEMPLATE_CATEGORY = `
  query GetTemplateCategory($id: ID!) {
    templateCategory(id: $id) {
      id
      name
      description
    }
  }
`;

export const CREATE_TEMPLATE_CATEGORY = `
  mutation CreateTemplateCategory($name: String!, $description: String) {
    createTemplateCategory(name: $name, description: $description) {
      templateCategory {
        id
        name
        description
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_TEMPLATE_CATEGORY = `
  mutation UpdateTemplateCategory($id: ID!, $name: String!, $description: String) {
    updateTemplateCategory(id: $id, name: $name, description: $description) {
      templateCategory {
        id
        name
        description
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_TEMPLATES_PAGINATED = `
  query GetTemplates($page: ID!, $q: String) {
    templates(page: $page, q: $q) {
     id
     name
    }
  }
`;

export const GET_TEMPLATES_BY_CATEGORY_NAME = `
  query GetTemplatesByCategoryName($templateCategoryName: String) {
    templates(templateCategoryName: $templateCategoryName) {
      id
      name
      templateCategory {
        id
        name
      }
    }
  }
`;

export const GET_DELAY_NOTIFICATION_TEMPLATES = `
  query GetDelayNotificationTemplates {
    templates(templateCategoryName: "delay") {
      id
      key
      body
      templateType
      name
      emailSubject
    }
  }
`;

